import { api, ApiError } from './client';

export type ChatAction =
  | 'picked'
  | 'skipped'
  | 'not_found'
  | 'added'
  | 'price_set';

export interface ChatSuccess {
  success: true;
  action: ChatAction;
  item?: string;
}

export interface ChatFailure {
  success: false;
  error: string;
  code: 'UNKNOWN_COMMAND' | 'NO_ACTIVE_SESSION' | 'ITEM_NOT_FOUND' | 'EMPTY_MESSAGE';
}

export const chatApi = {
  send: async (message: string): Promise<ChatSuccess | ChatFailure> => {
    try {
      return await api.post<ChatSuccess>('/chat', { message });
    } catch (err) {
      if (err instanceof ApiError) {
        // 422 from the backend carries a structured bot failure (ADR 018).
        return { success: false, error: err.message, code: err.code as ChatFailure['code'] };
      }
      return { success: false, error: 'Falha de conexão. Verifique a internet.', code: 'UNKNOWN_COMMAND' };
    }
  },
};
